import type { FaireProductEntity } from "../../entity_types/product";

export const p_g9e3kqusus: FaireProductEntity = {
  token: "p_g9e3kqusus",
  type: "product",
  name: "Essential Oil Warmer for Aromatherapy with Orbital Design",
  brandToken: "b_qqbr958t4u",
  brandName: "My Wholesale Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/e6bab5742c15a38fe696a82816aaafab4fa407939f157be51c228f653f236eb3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3ff0694a9b49f9375fe8886724c2b77fcaa88085c5dff708658a31419eae924.jpeg",
  ],
  priceDollars: 6.98,
  description:
    "Elevate your aromatherapy experience with our stylish Essential Oil Warmer featuring a sleek Orbital Design. Enjoy the benefits of your favorite essential oils while adding a touch of elegance to any room. Perfect for creating a relaxing atmosphere and promoting overall well-being.\n• Oil warmer weighs 0.4 lbs. And measures 3.5 inches by 3.5 inches by 3.5 inches. Fits perfectly on a shelf or table as meditative d&eacute;cor.\n• The oil warmer is made from glass with a metal stand that is easy to clean and provides gorgeous sculptural details.\n• Design a peaceful and aromatic ambience by warming and diffusing the essential oils of your choice. Simply pour your favorite scented oil into the top and light a candle underneath to create a tranquil and perfumed environment.\n• Clean with soap and water to remove remaining fragrance oils and candle residue before next use.\n• Perfect as a gift to use during meditation, yoga, or to simply make your home smell amazing. It works with practically any essential oil so feel free to create your own unique scents.",
  tags: [],
  msrpDollars: 13.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:04.071Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
